import React, { useState, useEffect } from 'react';
import styles from './AddTrainer.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { createTrainer } from '../../Redux/Actions/actions';
import { useNavigate } from 'react-router-dom';

const initialForm = {
  name: '',
  last_name: '',
  dni: '',
  email: '',
  phone_number: '',
  birth_date: '',
  gender: '',
  address: '',
  specialty: '',
  bio: '',
  profile_photo: '',
  monday: false,
  tuesday: false,
  wednesday: false,
  thursday: false,
  friday: false,
  saturday: false,
  sunday: false,
  status: true,
  observations: '',
};

const AddTrainer = () => {
  const dispatch = useDispatch();
  const { trainerLoading, trainerError, trainerCreated } = useSelector(state => state);
  const gym = useSelector(state => state.gym);
  const navigate = useNavigate();
  const [form, setForm] = useState(initialForm);

  useEffect(() => {
    if (trainerCreated) {
      navigate('/trainers');
    }
    if (trainerError) {
      alert(trainerError);
    }
  }, [trainerCreated, trainerError, navigate]);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!gym?.id) return alert('No se encontró el gimnasio logueado');
    dispatch(createTrainer({ ...form, gymId: gym.id }));
  };

  return (
    <div className={styles.container}>
      <form className={styles.form} onSubmit={handleSubmit}>
        <h2>Alta de Entrenador</h2>
        <label className={styles.label} htmlFor="name">Nombre</label>
        <input id="name" name="name" value={form.name} onChange={handleChange} required />

        <label className={styles.label} htmlFor="last_name">Apellido</label>
        <input id="last_name" name="last_name" value={form.last_name} onChange={handleChange} required />

        <label className={styles.label} htmlFor="dni">DNI</label>
        <input id="dni" name="dni" value={form.dni} onChange={handleChange} required />

        <label className={styles.label} htmlFor="email">Email</label>
        <input id="email" name="email" value={form.email} onChange={handleChange} />

        <label className={styles.label} htmlFor="phone_number">Teléfono</label>
        <input id="phone_number" name="phone_number" value={form.phone_number} onChange={handleChange} />

        <label className={styles.label} htmlFor="birth_date">Fecha de nacimiento</label>
        <input id="birth_date" name="birth_date" type="date" value={form.birth_date} onChange={handleChange} />

        <label className={styles.label} htmlFor="gender">Género</label>
        <select id="gender" name="gender" value={form.gender} onChange={handleChange}>
          <option value="">Género</option>
          <option value="Femenino">Femenino</option>
          <option value="Masculino">Masculino</option>
          <option value="Otro">Otro</option>
        </select>

        <label className={styles.label} htmlFor="address">Dirección</label>
        <input id="address" name="address" value={form.address} onChange={handleChange} />

        <label className={styles.label} htmlFor="specialty">Especialidad</label>
        <input id="specialty" name="specialty" value={form.specialty} onChange={handleChange} />

        <label className={styles.label} htmlFor="bio">Bio</label>
        <textarea id="bio" name="bio" value={form.bio} onChange={handleChange} />

        <label className={styles.label} htmlFor="profile_photo">Foto de perfil (URL)</label>
        <input id="profile_photo" name="profile_photo" value={form.profile_photo} onChange={handleChange} />

        <label className={styles.label}>Días de trabajo</label>
        <div className={styles.days}>
          <label><input type="checkbox" name="monday" checked={form.monday} onChange={handleChange} />Lunes</label>
          <label><input type="checkbox" name="tuesday" checked={form.tuesday} onChange={handleChange} />Martes</label>
          <label><input type="checkbox" name="wednesday" checked={form.wednesday} onChange={handleChange} />Miércoles</label>
          <label><input type="checkbox" name="thursday" checked={form.thursday} onChange={handleChange} />Jueves</label>
          <label><input type="checkbox" name="friday" checked={form.friday} onChange={handleChange} />Viernes</label>
          <label><input type="checkbox" name="saturday" checked={form.saturday} onChange={handleChange} />Sábado</label>
          <label><input type="checkbox" name="sunday" checked={form.sunday} onChange={handleChange} />Domingo</label>
        </div>

        <label className={styles.label} htmlFor="observations">Observaciones</label>
        <input id="observations" name="observations" value={form.observations} onChange={handleChange} />

        <button type="submit" disabled={trainerLoading}>
          {trainerLoading ? 'Guardando...' : 'Guardar entrenador'}
        </button>
        {trainerError && <p className={styles.error}>{trainerError}</p>}
        {trainerCreated && <p className={styles.success}>¡Entrenador creado correctamente!</p>}
      </form>
    </div>
  );
};

export default AddTrainer;